import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { BsArrowLeft } from "react-icons/bs";
import { FaRegFileAlt, FaEllipsisV } from "react-icons/fa";
import { RiMessageLine } from "react-icons/ri";
import { useGetSubscriptionQuery } from "../../../store/auth/authApi";

export default function SubscriptionsDetails() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("all");
  const [dropdownOpen, setDropdownOpen] = useState(null);

  // Get subscription details
  const {
    data: subscriptionData,
    isLoading,
    error,
  } = useGetSubscriptionQuery(id, {
    skip: !id,
  });

  console.log("Subscription Details:", {
    id,
    subscriptionData,
    isLoading,
    error,
  });

  const allSubscribers = [...Array(5)].map((_, index) => ({
    id: index,
    name: "Ifeoluwa C&C",
    location: "Akowonjo, Lagos",
    smsBalance: index === 2 ? "800 Balance" : "800",
    smsBalanceLabel: index === 2 ? "Branches" : "SMS Balance",
    totalMembers: 357,
    modules: "12 of 15",
    expiryDate: "31 Days",
    status: index % 2 === 0 ? "active" : "non-active",
  }));

  const activeSubscribers = allSubscribers.filter(
    (subscriber) => subscriber.status === "active"
  );
  const nonActiveSubscribers = allSubscribers.filter(
    (subscriber) => subscriber.status === "non-active"
  );

  const renderSubscribers = (subscribers) => {
    return subscribers.map((subscriber) => (
      <div
        key={subscriber.id}
        className="flex items-center justify-between p-6 hover:bg-gray-50 cursor-pointer"
      >
        <div className="flex items-center">
          <img
            src="/Images/Dashboard/image2.svg"
            alt="profile"
            className="rounded-full w-10 h-10 mr-4"
          />
          <div>
            <p className="text-gray-800 font-semibold">{subscriber.name}</p>
            <p className="text-gray-500 text-sm">{subscriber.location}</p>
          </div>
        </div>
        <div className="grid grid-cols-5 gap-4 items-center">
          <div>
            <p className="text-gray-800 font-semibold">
              {subscriber.smsBalance}
            </p>
            <p className="text-gray-500 text-sm">
              {subscriber.smsBalanceLabel}
            </p>
          </div>
          <div>
            <p className="text-gray-800 font-semibold">
              {subscriber.totalMembers}
            </p>
            <p className="text-gray-500 text-sm">Total Member</p>
          </div>
          <div>
            <p className="text-green-600 font-semibold">{subscriber.modules}</p>
            <p className="text-gray-500 text-sm">Number of Modules</p>
          </div>
          <div>
            <p className="text-red-600 font-semibold">
              {subscriber.expiryDate}
            </p>
            <p className="text-gray-500 text-sm">Expiry Date</p>
          </div>
          <div className="relative">
            <button
              onClick={() =>
                setDropdownOpen((prev) =>
                  prev === subscriber.id ? null : subscriber.id
                )
              }
              className="text-gray-400 text-xl cursor-pointer focus:outline-none"
            >
              <FaEllipsisV />
            </button>
            {dropdownOpen === subscriber.id && (
              <div className="absolute right-0 mt-2 w-52 bg-white rounded-md shadow-lg z-10">
                <button className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                  Renew Subscription
                </button>
                <button className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                  Suspend Subscription
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    ));
  };

  if (isLoading) {
    return (
      <div className="p-6 min-h-screen flex items-center justify-center">
        <div className="spinner-border text-primary" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    );
  }

  if (error || !subscriptionData) {
    return (
      <div className="p-6 min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-gray-800 mb-4">
            Subscription Not Found
          </h2>
          <button
            onClick={() => navigate("/subscriptions")}
            className="bg-[#8B313A] text-white px-4 py-2 rounded-md hover:bg-red-700"
          >
            Back to Subscriptions
          </button>
        </div>
      </div>
    );
  }

  const subscription = subscriptionData?.data || subscriptionData;

  return (
    <div className="p-6 min-h-screen">
      <div className="flex justify-between items-center mb-6 bg-white rounded-xl p-4">
        <div className="flex items-center">
          <BsArrowLeft
            className="text-xl text-gray-600 mr-4 cursor-pointer"
            onClick={() => navigate("/subscriptions")}
          />
          <h1 className="text-2xl font-bold text-gray-800">
            {subscription.name} Subscription
          </h1>
          <span className="ml-4 px-3 py-1 bg-[#8b313a]/10 text-[#8b313a] text-xs rounded-full">
            {subscription.name} plan
          </span>
        </div>
        <div className="flex items-center">
          <span className="text-gray-600 mr-2">Disable subscription</span>
          <label htmlFor="toggle" className="flex items-center cursor-pointer">
            <div className="relative">
              <input type="checkbox" id="toggle" className="sr-only" />
              <div className="block bg-gray-200 w-10 h-6 rounded-full"></div>
              <div className="dot absolute left-1 top-1 bg-white w-4 h-4 rounded-full transition"></div>
            </div>
          </label>
        </div>
      </div>

      <div className="bg-white p-4 rounded-lg flex items-center justify-between mb-8">
        <div className="flex items-center">
          <div className="bg-[#318c64]/10 p-3 rounded-full mr-4">
            <FaRegFileAlt className="text-[#318c64] text-2xl" />
          </div>
          <div>
            <p className="text-[#8b313a] font-bold text-2xl">
              Subscription Alert
            </p>
            <p className="text-[#858585]">
              Ifeoluwa Cooperative subscriptions will expire in 10 days, notify
              the cooperative to subscribe for new plan
            </p>
          </div>
        </div>
        <div className="flex items-center">
          <button className="bg-[#8b313a] text-white px-4 py-2 rounded-md text-sm mr-4">
            Send Message
          </button>
          <button className="text-red-700">
            <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
              <path
                fillRule="evenodd"
                d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                clipRule="evenodd"
              />
            </svg>
          </button>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 mb-8">
        <div className="bg-[#383838] h-fit p-6 rounded-lg shadow-sm mb-4">
          <div className="bg-white rounded-xl p-2 w-64 flex items-center gap-2">
            <div className="bg-red-100 p-3 rounded-full inline-block mb-4">
              <RiMessageLine className="text-[#8b313a] text-2xl" />
            </div>
            <div className="w-3/5">
              <p className="text-gray-800 text-3xl font-bold">
                {subscription.modules?.length || 0}
              </p>
              <p className="text-gray-600 text-sm">Features</p>
              <div className="w-full bg-[#e08a8e] rounded-full h-1.5 mt-2">
                <div
                  className="bg-[#8b313a] h-1.5 rounded-full"
                  style={{ width: "70%" }}
                ></div>
              </div>
            </div>
          </div>
          <button className="mt-6 bg-[#8b313a] text-white py-3 px-6 rounded-md text-sm hover:bg-red-700 transition">
            Edit Features
          </button>
        </div>

        <div className="lg:col-span-2 bg-white p-6 rounded-lg shadow-sm">
          <h3 className="text-lg font-semibold text-gray-800 mb-4">
            Recent Transactions
          </h3>
          <div className="divide-y divide-gray-200">
            {[...Array(5)].map((_, index) => (
              <div
                key={index}
                className="flex items-center justify-between py-2"
              >
                <div className="flex items-center">
                  <img
                    src="/Images/Dashboard/image1.svg"
                    alt="logo"
                    className="rounded-full w-8 h-8 mr-3"
                  />
                  <div>
                    <p className="text-gray-800">Olaoluwa C&C</p>
                    <p className="text-gray-500 text-sm">
                      {subscription.name} plan
                    </p>
                  </div>
                </div>
                <div className="flex items-center text-sm text-gray-600">
                  <span className="mr-4">22 Sep 2019</span>
                  <span className="mr-4">01:36AM</span>
                  <div>
                    <p className="text-green-600 font-semibold text-right">
                      NGN {subscription.price || "1,000.00"}
                    </p>
                    <p className="text-gray-500 text-sm ml-2">
                      Subscription renewal
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="bg-white rounded-lg shadow-sm">
        <div className="border-b border-gray-200">
          <nav className="-mb-px flex space-x-8 px-6" aria-label="Tabs">
            <button
              onClick={() => setActiveTab("all")}
              className={`border-b-2 ${
                activeTab === "all"
                  ? "border-[#8b313a] text-[#1e1e1e] font-semibold text-lg"
                  : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
              } p-1`}
            >
              All subscribers
            </button>
            <button
              onClick={() => setActiveTab("active")}
              className={`border-b-2 ${
                activeTab === "active"
                  ? "border-[#8b313a] text-[#1e1e1e] font-semibold text-lg"
                  : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
              } p-1`}
            >
              Active subscribers
            </button>
            <button
              onClick={() => setActiveTab("non-active")}
              className={`border-b-2 ${
                activeTab === "non-active"
                  ? "border-[#8b313a] text-[#1e1e1e] font-semibold text-lg"
                  : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
              } p-1`}
            >
              Non-active subscribers
            </button>
          </nav>
        </div>

        <div className="divide-y divide-gray-200">
          {activeTab === "all" && renderSubscribers(allSubscribers)}
          {activeTab === "active" && renderSubscribers(activeSubscribers)}
          {activeTab === "non-active" &&
            renderSubscribers(nonActiveSubscribers)}
        </div>
      </div>
    </div>
  );
}
